import { apiTypes } from '../../../../../shared/consts/handbooksApiTypes';

const tabsTitles = {
  notification_addresses_groups: 'Группы адресатов',
  notification_addresses:        'Адресаты',
  notification_events:           'Рассылка уведомлений'
};

const config = {
  schema:             'smsv',
  title:              'Система мониторинга состояния водителя',
  multipleConfig:     true,
  tabsTitles,
  defaultSelectedTab: 'notification_addresses_groups',
  tabs:               {
    notification_addresses_groups: {
      schema:         'smsv',
      table:          'addr_group',
      title:          tabsTitles.notification_addresses_groups,
      apiType:        apiTypes.DEFAULT,
      elemsOnPage:    100,
      connections:    {},
      fields:         [
        {
          name:          'id',
          title:         'ID записи',
          index:         true,
          type:          'number',
          width:         '120px',
          disableFilter: true,
        },
        {
          name:  'name',
          title: 'Группа адресатов',
          type:  'text',
        },
      ],
      makeIdOnInsert: false,
      hideExport:     true,
      hideImport:     true,
      defaultSort:    {
        field:     'id',
        direction: 'desc',
      },
      newTemplate:    {
        name: '',
      },
    },
    notification_addresses:        {
      schema:         'smsv',
      table:          'addr_address_ui',
      title:          tabsTitles.notification_addresses,
      apiType:        apiTypes.DEFAULT,
      elemsOnPage:    100,
      connections:    {
        addr_group: {
          apiType: apiTypes.DEFAULT,
          schema:  'smsv',
          table:   'addr_group',
          index:   'id',
          fields:  ['name'],
          format:  (elem: any) => elem['name'],
        },
      },
      fields:         [
        {
          name:          'id',
          title:         'ID записи',
          index:         true,
          type:          'number',
          width:         '120px',
          disableFilter: true,
        },
        {
          name:     'name',
          title:    'Адресат',
          type:     'text',
          required: true,
        },
        {
          name:     'type',
          title:    'Тип адресата',
          type:     'list',
          required: true,
          values:   [
            { key: null, value: '' },
            { key: 0, value: 'Групповой' },
            { key: 1, value: 'Индивидуальный' },
          ],
        },
        {
          name:     'communication_type',
          title:    'Способ связи',
          type:     'list',
          required: false,
          values:   [
            { key: null, value: '' },
            { key: 0, value: 'МАХ' },
            { key: 1, value: 'Электронная почта' },
            { key: 2, value: 'МАХ и электронная почта' },
          ],
        },
        {
          name:     'messenger',
          title:    'ID пользователя/чата в МАХ',
          type:     'text',
          required: false,
        },
        {
          name:     'mail',
          title:    'Адрес электронной почты',
          type:     'text',
          validate: (value: any) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),
          validateError: 'Допустим только валидный email',
          required: false,
        },
        {
          name:       'groups',
          title:      'Группа адресатов',
          type:       'connetioncombobox',
          connection: 'addr_group',
          required:   false
        },
      ],
      makeIdOnInsert: false,
      hideExport:     true,
      hideImport:     true,
      defaultSort:    {
        field:     'id',
        direction: 'desc',
      },
      newTemplate:    {
        name:               '',
        type:               null,
        communication_type: null,
        messenger:          '',
        mail:               '',
        groups:             [],
      },
    },
    notification_events:           {
      schema:         'smsv',
      table:          'addr_event_to_group',
      title:          tabsTitles.notification_events,
      apiType:        apiTypes.DEFAULT,
      elemsOnPage:    100,
      connections:    {
        incident_type: {
          apiType: apiTypes.DEFAULT,
          schema:  'smsv',
          table:   'incident_type',
          index:   'incident_type_id',
          fields:  ['incident_type_short_name'],
          format:  (elem: any) => elem['incident_type_short_name'],
        },
        addr_group:    {
          apiType: apiTypes.DEFAULT,
          schema:  'smsv',
          table:   'addr_group',
          index:   'id',
          fields:  ['name'],
          format:  (elem: any) => elem['name'],
        },
      },
      fields:         [
        {
          name:          'id',
          title:         'ID записи',
          index:         true,
          type:          'number',
          width:         '120px',
          disableFilter: true,
        },
        {
          name:       'event_type',
          title:      'Тип события',
          type:       'number',
          required:   true,

          connection: 'incident_type',
        },
        {
          name:       'group_id',
          title:      'Группа адресатов',
          type:       'number',
          required:   true,
          connection: 'addr_group',
        },
        {
          name:     'media_type',
          title:    'Наличие медиафайлов',
          type:     'list',
          required: false,
          values:   [
            { key: null, value: '' },
            { key: 0, value: 'Все события' },
            { key: 1, value: 'Только с фото и видео' },
            { key: 2, value: 'С фото или видео' },
          ],
        },
        {
          name:     'moderation_type',
          title:    'Модерация событий',
          type:     'list',
          required: false,
          values:   [
            { key: null, value: '' },
            { key: 0, value: 'Все события' },
            { key: 1, value: 'Прошли модерацию' },
            { key: 2, value: 'Подтвержденные' },
          ],
        },
        {
          name:     'is_has_photo',
          title:    'Вложение фото',
          type:     'boolean',
          required: false,
        },
        {
          name:     'is_has_video',
          title:    'Ссылка на видео',
          type:     'boolean',
          required: false,
        },
      ],
      makeIdOnInsert: false,
      hideExport:     true,
      hideImport:     true,
      defaultSort:    {
        field:     'id',
        direction: 'desc',
      },
      newTemplate:    {
        event_type:      null,
        group_id:        null,
        media_type:      null,
        moderation_type: null,
        is_has_photo:    false,
        is_has_video:    false,
      },
    }
  }
};

export default config;